<template>
  <div class="min-vh-100 d-flex align-items-center justify-content-center bg-gray-100">
    <div class="col-xl-4 col-lg-5 col-md-7 col-11">
      <div class="card z-index-0">
        <div class="card-header text-center pt-4 pb-1">
          <h5 class="font-weight-bolder mb-1">数据后台</h5>
          <p class="mb-0 text-sm text-muted">请登录您的账号</p>
        </div>
        <div class="card-body px-4 pb-4">
          <div v-if="error" class="alert alert-danger text-white text-sm py-2 mb-3" role="alert">
            {{ error }}
          </div>
          <form @submit.prevent="handleLogin">
            <div class="mb-3">
              <input
                v-model="form.username"
                type="text"
                class="form-control form-control-lg"
                placeholder="用户名"
                autocomplete="username"
              />
            </div>
            <div class="mb-3">
              <input
                v-model="form.password"
                type="password"
                class="form-control form-control-lg"
                placeholder="密码"
                autocomplete="current-password"
              />
            </div>
            <div class="text-center mt-4">
              <button
                type="submit"
                class="btn btn-success btn-lg w-100 mb-0"
                :disabled="loading"
              >
                {{ loading ? '登录中...' : '登 录' }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoginPage",
  data() {
    return {
      form: { username: "", password: "" },
      loading: false,
      error: "",
    };
  },
  beforeMount() {
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
  },
  beforeUnmount() {
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
  },
  methods: {
    async handleLogin() {
      this.error = "";
      if (!this.form.username || !this.form.password) {
        this.error = "请填写用户名和密码";
        return;
      }
      this.loading = true;
      try {
        const res = await fetch("/api/auth/login", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(this.form),
        });
        const json = await res.json();
        if (json.code !== 0) {
          this.error = json.msg || "登录失败";
          return;
        }
        const { token, username, role, perms } = json.data;
        localStorage.setItem("token", token);
        localStorage.setItem("username", username);
        localStorage.setItem("role", role);
        localStorage.setItem("perms", JSON.stringify(perms));
        this.$router.push("/dashboards/dashboard-default");
      } catch (e) {
        this.error = "网络错误，请检查后端服务是否启动";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
